<script>
import timeMixin from "@/mixins/timeMixin.js";
import subscriptionStates from "@/utils/states/subscription";

export default {
  mixins: [timeMixin],
  props: {
    subscription: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      state: null
    };
  },
  methods: {
    setState() {
      this.state = subscriptionStates.getState(this.subscription.status);
    }
  },
  mounted() {
    this.setState();
  }
};
</script>

<template>
  <section>
    <div class="professional">
      <img src="https://www.donamaid.com/dist/donie.png" @error="$event.target.src='/static/donie.svg'" alt="Donamaid Manager" />
    </div>

    <div class="details">
      <div class="name">
        {{subscription.name}}
        <div v-if="state" :class="'chip '+state.color">{{state.name}}</div>
      </div>Pedidos com
      <b>{{subscription.order_duration | secToHours}} horas</b> de duração com
      <b>{{subscription.professional.account.first_name}} {{subscription.professional.account.last_name}}</b>
    </div>
  </section>
</template>

<style scoped>
section {
  display: flex;
  align-items: center;
}

section .details {
  font-size: 14px;
}

section .details b {
  color: var(--purple);
}

section .details .name {
  display: flex;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
  color: var(--purple);
  margin-bottom: 5px;
}

section .details .name .chip {
  padding: 5px 10px;
  font-weight: normal;
  text-transform: lowercase;
  font-size: 10px;
  margin-left: 5px;
}

section .professional {
  border-radius: 100%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

section .professional img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

hr {
  border: 1px solid #eee;
  background: none;
  margin: 20px 0;
}

.cycles {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.cycle-card {
  border: 2px solid #ccc;
  border-radius: 4px;
  padding: 10px 20px;
  margin: 5px;
}

@media (max-width: 480px) {
  section {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions/Subscription/Header.vue